// extracted by mini-css-extract-plugin
module.exports = {"container":"SendVerificationEmail__container--tNv","input":"SendVerificationEmail__input--WG5","button":"SendVerificationEmail__button--3pD"};